import axios from 'axios'
import qs from 'qs'
import store from '@/store'

const client = axios.create({
  baseURL: null,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  },
  paramsSerializer: params => {
    return qs.stringify(params, { arrayFormat: 'brackets' })
  }
})

client.interceptors.request.use(
  config => {
    if (store && store.getters.authenticated) {
      config.headers = Object.assign(config.headers, {
        Authorization: `Bearer ${store.getters.accessToken}`
      })
    }

    return {
      ...config,
      onUploadProgress: config.onUploadProgress,
      onDownloadProgress: config.onDownloadProgress
    }
  },
  error => Promise.reject(error)
)

export default client
